import React from 'react';
import ReactDOM from 'react-dom';
import 'isomorphic-fetch';
import 'es6-promise';
import App from './app';

ReactDOM.render(<App />, document.getElementById('app'));
